export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss'
export const ISO_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
